import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import PinInput from 'react-pin-input';
import { logoVoxel } from '../../imagepath';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../../services/ApiService.js';
import Loader from '../../../common/loader.jsx';
import { ErrorMessage } from '@hookform/error-message';
import { notification } from 'antd';
import apiService from '../../../axios/apiService';
import { useUser } from '../../../hooks/useUser.js';
import { useUserToken } from '../../../hooks/useToken.js';
import { LOGIN_FORM_TYPES } from '../../../appContants.js';
import AppMascot from './AppMascot.jsx';
import PropTypes from "prop-types";

const Login = () => {
  const { setUserToken } = useUserToken();
  const navigate = useNavigate();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  // otp
  const [cognitoUser, setCognitoUser] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const [showPassword, setShowPassword] = useState(false);
  const { setUser } = useUser();
  const [formDataForOtp, setFormDataForOtp] = useState(null);
  const [timerKey, setTimerKey] = useState(0);
  const [isOtpTimerActive, setIsOtpTimerActive] = useState(false);
  const [trustDevice, setTrustDevice] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  let inputRef = useRef();
  const CallMe = async () => {
    try {
      let user = await apiService.callme();
      if (user) {
        // Persist user on local storage
        setUser(user);

        navigate('user/admin-dashboard');
      }
    } catch (error) {
      api.error({
        message: error?.message || 'Error',
        description: 'something went wrong!!',
        showProgress: false,
      });
      setIsLoading(false);
    }
  };

  const handleDeviceTrusted = async (user) => {
    setUserToken(user.signInUserSession.idToken.jwtToken);
    setCognitoUser(user);
    await CallMe();
  };

  return (
    <>
      {contextHolder}
       {/* Main Wrapper */}
      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            {/* Login logo */}
            <AppMascot></AppMascot>
            {/* /Login logo */}
            {/* Login Content */}
            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <div className="account-logo">
                        <Link to="/admin-dashboard">
                          <img 
                          src={logoVoxel} 
                          alt="#" 
                          style={{ height: 130 }} 
                          />
                        </Link>
                      </div>
                      <h2>
                        {cognitoUser?.challengeName === 
                        LOGIN_FORM_TYPES.NEW_PASSWORD_REQUIRED
                          ? 'Update Password'
                          : 'Login'}
                      </h2>
                      {/* Form */}
                      {cognitoUser?.challengeName === 
                      LOGIN_FORM_TYPES.NEW_PASSWORD_REQUIRED ? (
                        <form
                          onSubmit={handleSubmit(async (data) => {
                            try {
                              setIsLoading(true);
                              let user = await ApiService.updateNewUserPassword(
                                cognitoUser, 
                                data
                              );
                              if (user) {
                                setCognitoUser(user);
                                reset();
                                if (
                                  !user?.challengeName &&
                                  user?.signInUserSession
                                ) {
                                  await handleDeviceTrusted(user);
                                }
                              } else {
                              setIsLoading(false);
                              api.error({
                                  message: 'Error',
                                  description:
                                    'Something is wrong!!',
                                  showProgress: false,
                                });
                              }
                            } catch (error) {
                              setIsLoading(false);
                            }
                          })}
                        >
                          <div className="form-group">
                            <label>
                              Password <span className="login-danger">*</span>
                              </label>
                            <input
                              ref={inputRef}
                              className="form-control pass-input"
                              type={showPassword ? 'text' : 'password'}
                              {...register('password', { required: true })}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.password && <p>Please enter password</p>}
                            </small>
                            <ErrorMessage errors={errors} name="password" />

                            <span
                              className="profile-views feather-eye-off toggle-password"
                              onClick={togglePasswordVisibility}
                            >
                              <FeatherIcon icon={showPassword ? "eye-off" : "eye"} />
                            </span>
                          </div>
                          <div className="form-group login-btn">
                            <button 
                            className="btn btn-primary btn-block" 
                            type="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      ) : null}

                      {/* OTP FORM */}
                      {cognitoUser?.challengeName === LOGIN_FORM_TYPES.CUSTOM_CHALLENGE ? (
                        <div className="login-otp-section">
                          {isOtpTimerActive && (
                            <p className="login-otp-message">
                              6-digit code sent to <strong>{formDataForOtp?.email}</strong>.
                              Valid for 10 minutes.
                            </p>
                          )}

                          <PinInput
                              length={6}
                              type="numeric"
                              inputMode="number"
                              style={{ padding: 0, margin: '0 0 16px', width: '100%' }}
                              inputStyle={{
                                width: '48px',
                                height: '48px',
                                margin: 0,
                                padding: 0,
                                fontSize: '20px',
                                fontWeight: 600,
                                textAlign: 'center',
                                border: '2px solid rgba(46, 55, 164, 0.1)',
                                borderRadius: '10px',
                                background: '#fff',
                                color: '#333448',
                              }}
                              inputFocusStyle={{
                                borderColor: 'rgb(74 83 199 / 80%)',
                                outline: 'none',
                                boxShadow: 'none',
                              }}
                              onComplete={async (value) => {
                                if (value.length) {
                                  try {
                                    setIsLoading(true);
                                    let user = await ApiService.authOtpSignIn(cognitoUser, value);

                                    if (user?.signInUserSession) {
                                      setUserToken(
                                        user.signInUserSession.idToken.jwtToken
                                      );
                                      setCognitoUser(user);
                                      if (trustDevice && formDataForOtp?.email) {
                                        await ApiService.rememberDevice(formDataForOtp.email);
                                      }
                                      CallMe();
                                    } else {
                                      api.error({
                                        message: 'Error',
                                        description: 'Invalid verification code!!',
                                      });
                                      setIsLoading(false);
                                    }
                                  } catch (error) {
                                    api.error({
                                      message: 'Error',
                                      description: error,
                                    });
                                  }
                                }
                              }}
                            />

                          <label
                            className="login-otp-trust"
                            title="Skip email code on this browser next time. Only check once per device."
                          >
                            <input
                              type="checkbox"
                              checked={trustDevice}
                              onChange={(e) => setTrustDevice(e.target.checked)}
                            />
                            Trust this device
                          </label>

                          <div className="forgotpass login-otp-actions">
                            <ReverseTimer
                              key={timerKey}
                              duration={10 * 60} // 10 minutes
                              onExpire={() => console.log("Timer expired")}
                              onResend={async () => {
                                try {
                                  setIsLoading(true);
                                  const res = await ApiService.logIn(formDataForOtp);

                                  if (res) {
                                    api.success({
                                      message: "OTP Sent",
                                      description: "A new OTP has been sent.",
                                    });
                                    setTimerKey((k) => k + 1);
                                  }
                                } catch (err) {
                                  api.error({
                                    message: "Error",
                                    description: "Failed to resend OTP",
                                  });
                                } finally {
                                  setIsLoading(false);
                                }
                              }}
                              onActiveChange={setIsOtpTimerActive}
                            />
                            <Link onClick={() => { setCognitoUser(null); setTrustDevice(false); }} >Back To Login</Link>
                          </div>
                        </div>
                      ) : null}

                      {/* LOGIN FORM */}
                      {!cognitoUser && (
                        <form
                          onSubmit={handleSubmit(async (data) => {
                            try {
                              setIsLoading(true);
                              let user = await ApiService.logIn(data);

                              if (user) {
                                setFormDataForOtp(data);
                                if (
                                  user?.challengeName ===
                                  LOGIN_FORM_TYPES.CUSTOM_CHALLENGE
                                ) {
                                  setCognitoUser(user);
                                  reset();
                                } else if (
                                  !user?.challengeName &&
                                  user?.signInUserSession
                                ) {
                                  await handleDeviceTrusted(user);
                                } else {
                                  setCognitoUser(user);
                                  reset();
                                }
                              } else {
                                api.error({
                                  message: 'Error',
                                  description: 'Your username or password is wrong!',
                                });
                              }
                              setIsLoading(false);
                            } catch (error) {
                              setIsLoading(false);
                            }
                          })}
                        >
                          <div className="form-group">
                            <label>Email <span className="login-danger">*</span></label>
                            <input
                              className="form-control"
                              type="text"
                              {...register('email', {
                                required: 'Please Enter Your Email!',
                                pattern: {
                                  value: 
                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                  message: 'Please Enter A Valid Email!',
                                },
                              })}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.email?.message}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Password <span className="login-danger">*</span></label>
                            <input
                              ref={inputRef}
                              className="form-control pass-input"
                              type={showPassword ? 'text' : 'password'}
                              {...register('password', { required: true })}
                            />
                            <small style={{ color: 'red' }}>
                              {errors.password && <p>Please enter password</p>}
                            </small>

                            <span
                              className="profile-views feather-eye-off toggle-password"
                              onClick={togglePasswordVisibility}
                            >
                              <FeatherIcon icon={showPassword ? "eye-off" : "eye"} />
                            </span>
                          </div>
                          <div className="forgotpass">
                            <Link to="/forgotpassword">Forgot Password?</Link>
                          </div>
                          <div className="form-group login-btn">
                            <button 
                            className="btn btn-primary btn-block" 
                            type="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Login Content */}
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

// ⏳ Reverse Timer Component (10 MINUTES)
export const ReverseTimer = ({ duration, onExpire, onResend, onActiveChange }) => {
  const [timeLeft, setTimeLeft] = useState(duration);
  const [isActive, setIsActive] = useState(true);
  const timerRef = useRef(null);

  useEffect(() => {
    onActiveChange?.(isActive && timeLeft > 0);
  }, [isActive, timeLeft]);

  useEffect(() => {
    if (isActive && timeLeft > 0) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }

    if (timeLeft === 0) {
      clearInterval(timerRef.current);
      onExpire?.();
    }

    return () => clearInterval(timerRef.current);
  }, [isActive, timeLeft]);

  const handleResend = async () => {
    setIsActive(false);
    clearInterval(timerRef.current);

    try {
      await onResend?.();
      setTimeLeft(duration);
      setIsActive(true);
    } catch (err) {
      console.error("Resend failed:", err);
    }
  };

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {timeLeft > 0 ? (
        <span>Resend OTP in {formatTime(timeLeft)}</span>
      ) : (
        <a
          onClick={handleResend}
          style={{ color: "#1890ff", cursor: "pointer", fontWeight: 500 }}
        >
          Resend OTP
        </a>
      )}
    </div>
  );
};

ReverseTimer.propTypes = {
  duration: PropTypes.number.isRequired,
  onExpire: PropTypes.func,
  onResend: PropTypes.func,
  onActiveChange: PropTypes.func,
};

export default Login;
